import { loadLanguageAsync } from "../../i18n";

export default {
  state: {
    blackList: [],
    isLoadingStr: "",
    currentLanguage: "",
    languages: []
  },
  getters: {
    currentLanguage: state => state.currentLanguage,
    languages: state => state.languages,
    blackList: state => state.blackList,
    isLoadingStr: state => state.isLoadingStr
  },
  mutations: {
    changeLanguage(state, lang) {
      state.currentLanguage = lang;
    },
    setLanguages(state, languages) {
      state.languages = languages;
    },
    addInBlackList(state, el) {
      state.blackList.push(el);
    },
    setIsLoadingStr(state, isLoadingStr) {
      state.isLoadingStr = isLoadingStr;
    }
  },
  actions: {
    addInBlackList({ commit }, val) {
      return new Promise((resolve /*, reject*/) => {
        commit("addInBlackList", val);
        resolve();
      });
    },
    setIsLoadingStr({ commit }, val) {
      return new Promise((resolve /*, reject*/) => {
        commit("setIsLoadingStr", val);
        resolve();
      });
    },
    changeLanguage({ commit }, lang) {
      console.log("changeLanguage to " + lang);
      return new Promise((resolve /*, reject*/) => {
        loadLanguageAsync(lang).then(() => {
          commit("changeLanguage", lang);
          commit("setAppLanguage", lang);
          resolve();
        });
      });
    },
    forceChangeLanguage({ commit }, lang) {
      if (!lang) {
        var currLang = "" + document.querySelector("html").getAttribute("lang");
        if (currLang == "en") {
          currLang = "en-US";
        }
        lang = currLang;
      }
      console.log("forceChangeLanguage to " + lang);
      return new Promise((resolve /*, reject*/) => {
        loadLanguageAsync(lang, true).then(() => {
          commit("changeLanguage", lang);
          resolve();
        });
      });
    },
    setLanguages({ commit }, languages) {
      commit("setLanguages", languages);
    }
  }
};
